import {combineReducers} from 'redux';
import store from '../stores/store';

import {
  LUSER_INIT,
  LUSER_TOGGLE_MENU,
  LUSER_TOGGLE_FOLLOW,
  LUSER_CHECK_FOLLOWED_INTEGRITY,
  LUSER_FOLLOW,
  LUSER_UNFOLLOW,
  LUSER_SET_FOLLOW
} from '../actions/luserAction';

export default function reducer(initialState={
    id: null,
    name: null,
    firstname: null,
    lastname: null,
    current_title: null,
    picture: null,
    insider: false,

    followedThreadIds: [],
    read_thread_ids: [],
    participatedin_thread_ids: [],

    menu_opened: false
  }, action) {

    switch (action.type) {


      case LUSER_INIT: {
        const luser = action.payload;
        return {...initialState, ...luser}

      }

      case LUSER_TOGGLE_MENU: {
        let state = (initialState.menu_opened === true ? false : true);
        if (typeof action.state !== 'undefined' && (action.state === true || action.state === false)){
          state = action.state;
        }
        return {
          ...initialState,
          menu_opened: state
        }

      }

      case LUSER_TOGGLE_FOLLOW: {
        // http post request in chatMiddleware
        break;
      }

      case LUSER_FOLLOW: {
        let followed_thread_ids = initialState.followedThreadIds;
        if (followed_thread_ids.indexOf(parseInt(action.thread_id)) == -1) {
          followed_thread_ids.push(action.thread_id);

          return {
            ...initialState,
            followedThreadIds: [...followed_thread_ids]
          }
        }

      }

      case LUSER_UNFOLLOW: {
        let followed_thread_ids = initialState.followedThreadIds;
        const index = followed_thread_ids.indexOf(parseInt(action.thread_id));
        if (index >= 0){
          followed_thread_ids.splice(index, 1);
        }
        return {
          ...initialState,
          followedThreadIds: [...followed_thread_ids]
        }
      }

      case LUSER_SET_FOLLOW: {
        console.log('SET FOLLOW');
        console.log(action);
        return {
          ...initialState,
          followedThreadIds: action.followedThreadIds
        }

      }

      case LUSER_CHECK_FOLLOWED_INTEGRITY:
      {
        let followed_thread_ids = initialState.followedThreadIds;
        let followed_index_to_delete = [];
        followed_thread_ids && followed_thread_ids.map((followed_thread_id, index) => {
          let founded = false;
          store.getState().threads.list.map(thread => {
            if (thread.id === followed_thread_id){
              founded = true;
              return;
            }
          });
          if (!founded){
            followed_index_to_delete.push(index);
          }
        });
        followed_index_to_delete && followed_index_to_delete.map(followed_thread_index_to_delete => {
          followed_thread_ids.splice(followed_thread_index_to_delete, 1);
        })
        return {
          ...initialState,
          followedThreadIds: [...followed_thread_ids]
        }

      }
    }

    return initialState;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/luserReducer.jsx